import {useTranslation} from "react-i18next";

const Loading = ({className}) => {
    const {t,} = useTranslation()
    return (
        <div className={`loading ${className}`} data-testid={'loading'}>{t('Loading')}</div>
    )
}

export default Loading;